export default {
  MES_REMUNERATIONS: {
    TITLE: 'My Compensation',
    YEAR_LABEL: 'Year',
    NET_SALARY: 'Net Salary',
    EVOLUTION: 'Evolution',
    EVOLUTION_SUBTITLE: 'compared to last year',
    OTHER_BENEFITS: 'Other Benefits',
    COMPANY_INVESTMENT: 'Company Investment',
    BONUSES: 'Bonuses',
    EMPLOYER_CHARGES: 'Employer Charges',
    NO_DATA_FOR_YEAR: 'No data available for this year',
    ERROR_LOADING_DATA: 'Error loading compensation data',
    NO_BENEFITS_TITLE: 'No benefits available',
    NO_BENEFITS_TEXT: 'No benefits data has been recorded for the year {{year}}. Benefits will be displayed as soon as they become available.',
  },
  GERER_REMUNERATIONS: {
    TITLE: 'Manage Compensation',
    ADD_COLUMN: 'Add Column',
    ADD_CATEGORY: 'Add Category',
    EDIT_COLUMN: 'Edit Column',
    DELETE_COLUMN: 'Delete Column',
    SAVE_SUCCESS: 'Changes saved successfully',
    SAVE_ERROR: 'Error saving changes',
  },
  COLUMN_TYPES: {
    TEXT: 'Text',
    NUMERIC: 'Numeric',
    DATE: 'Date',
  },
  MESSAGES: {
    COLUMN_CREATED: 'Column created successfully',
    COLUMN_UPDATED: 'Column updated successfully',
    COLUMN_DELETED: 'Column deleted successfully',
    CATEGORY_CREATED: 'Category created successfully',
    CATEGORY_UPDATED: 'Category updated successfully',
    VALUE_CREATED: 'Value created successfully',
    VALUE_UPDATED: 'Value updated successfully',
    VALUE_DELETED: 'Value deleted successfully',
  },
  CELL_CLEAR: {
    PROTECTED: 'Historical, source-backed, and read-only values cannot be cleared.',
    FORMULA_STORAGE_TYPE: 'Resetting this formula requires a numeric storage type. Reload the table to obtain its current configuration.',
    DEPENDENT: 'This value is used in calculations and cannot be cleared. Zero remains a valid value.',
    AMBIGUOUS: 'This monthly cell contains duplicate records, or its records do not match the selected period.',
    NO_OVERRIDE: 'There is no saved override to remove. The calculated value is kept.',
    PENDING_EDITS: 'Save or discard other pending edits before resetting a calculated value.',
    INVALID_FORMULA: 'The formula cannot be calculated safely. The saved value has been kept.',
    RESET_REFRESH_ERROR: 'The stored override was removed, but the table could not be refreshed. Reload to verify the calculated value.',
    UNAVAILABLE: 'Clearing is not available for this value. Reload the page or check the server version.',
    BUSY: 'Please wait until the current save finishes before clearing a value.',
    INVALID_INPUT: 'Enter a valid value or clear the field completely.',
    ERROR: 'The value could not be cleared. The previous value has been kept.',
  },
  AUTOSAVE: {
    NO_CHANGES: 'No changes to save',
    SAVE_SUCCESS: '{{count}} value(s) saved successfully',
    SAVE_ERROR: 'Error saving changes. Unsaved values have been kept.',
    IN_PROGRESS: 'Automatic saving is in progress. Please wait before leaving this page.',
    SAVING: 'Saving...',
    SAVED: 'Saved automatically',
    REFRESH_ERROR: 'The value was saved, but the table could not be synchronized. Refresh the page to verify it.',
    CALCULATED_SAVE_ERROR: 'Some calculated results could not be saved for history. Displayed calculations are unchanged. Reload the page to retry.',
  },
  COLUMN_SEARCH: {
    PLACEHOLDER: 'Search for a column...',
    NO_RESULTS: 'No matching columns.',
  },
  SUMMARY_BADGE: {
    SUM: 'Sum',
    AVERAGE: 'Average',
    HIDDEN: 'Hidden',
    HELP: 'Badges show saved automatic calculations for the selected tab, or the current tab if none is selected.',
  },
  SUMMARY_YEAR: {
    TITLE: 'Green summary table',
    SCOPE_HELP: 'Configure totals and averages for the selected tab. Variable years change labels only, not calculations or source data.',
    SAVE_ERROR: 'The column exists, but its summary settings could not be saved. Retry saving the settings.',
  },
  SYNTHESIS: {
    TITLE: 'Compensation Synthesis',
    UPDATE_DATE: 'Update date',
    PERSONAL_DATA: 'Personal data',
    ASSIGNMENT_DATA: 'Assignment data',
    CONTRACT_DATA: 'Contract data',
    MATRICULE: 'ID Number',
    NAME: 'Name',
    BIRTH_DATE: 'Date of birth',
    GENDER: 'Gender',
    DEPARTMENT: 'Department',
    POSITION: 'Position',
    MANAGER: 'Hierarchical manager',
    COUNTRY: 'Country',
    SITE: 'Site',
    COMPANY: 'Company',
    COMPANY_ENTRY_DATE: 'Company entry date',
    GROUP_ENTRY_DATE: 'Group entry date',
    CONTRACT_TYPE: 'Contract type',
    FIXED_REMUNERATION: 'Fixed remuneration',
    CAMPAIGN_ATTRIBUTES: 'Campaign attributes',
    VARIABLE_ELEMENTS: 'Variable elements',
    DATE: 'Date',
    REASON: 'Reason',
    TYPE: 'Rem type',
    LEVEL: 'Level',
    FIXED_SALARY: 'Fixed salary',
    INCREASE_AMOUNT: 'Increase amount',
    PERCENTAGE: '%',
    BASE_SALARY: 'Base salary',
    TOTAL: 'TOTAL',
    NO_DATA: 'No data available',
    CLOSE: 'Close',
  },
  REPORTING: {
    TITLE: 'Dashboard - Reporting',
    PERIOD: 'Period',
    MONTHLY_VIEW: 'Monthly view',
    YEARLY_VIEW: 'Yearly view',
    FILTER_SUPER_CATEGORY: 'Filter by super category',
    FILTER_CATEGORY: 'Filter by category',
    ALL_SUPER_CATEGORIES: 'All super categories',
    ALL_CATEGORIES: 'All categories',
    TOTAL_EMPLOYEES: 'Employees',
    TOTAL_KPIS: 'KPIs',
    CATEGORIES: 'Categories',
    COLUMNS: 'Columns',
    KPIS_BY_CATEGORY: 'KPIs by category',
    NO_DATA: 'No data available to generate KPIs',
    EXPORT_EXCEL: 'Export to Excel',
    SIMULATION_MODE: 'Simulation Mode',
    SIMULATION_MODE_DESC: 'KPIs automatically update when you modify values in the table, without requiring a save.',
  },
  SETTINGS: {
    TITLE: 'Compensation Settings',
    DESCRIPTION: 'Manage settings and access for the compensation module',
    VISIBILITY_SETTINGS: 'Visibility Settings',
    VISIBLE_COLLABORATEUR: 'Visible to employees',
    VISIBLE_COLLABORATEUR_DESC: 'Employees can view their own compensation data',
    VISIBLE_MANAGER: 'Visible to managers',
    VISIBLE_MANAGER_DESC: 'Managers can view compensation data for their teams',
    HIDE_MONTHLY_VIEW_MANAGER: 'Hide monthly view for payroll managers',
    HIDE_MONTHLY_VIEW_MANAGER_DESC: 'Payroll managers will only be able to access the yearly view',
    MONTHLY_VIEW_HIDDEN_FOR_MANAGER: 'Monthly view hidden for payroll managers',
    MONTHLY_VIEW_VISIBLE_FOR_MANAGER: 'Monthly view visible for payroll managers',
    ADMIN_PAIES: 'Payroll Administrators',
    SELECT_USER_ADMIN: 'Select a user',
    ADD_ADMIN: 'Add admin',
    ADMIN_ADDED: 'Payroll administrator added successfully',
    ADMIN_REMOVED: 'Payroll administrator removed successfully',
    NO_ADMIN_PAIES: 'No payroll administrators configured',
    CONFIRM_REMOVE_ADMIN: 'Confirm removal',
    CONFIRM_REMOVE_ADMIN_DESC: 'Are you sure you want to remove this user as a payroll administrator?',
    CHOOSE_USER: 'Choose a user',
    SELECT_USER: 'Please select a user',
    CONTRACT_VISIBILITY: 'Visible Contracts',
    CONTRACT_VISIBILITY_DESC: 'Select the contract types that will be visible in compensation management',
    NO_CONTRACTS: 'No contracts available',
    CONTRACTS_SELECTED: 'contract(s) selected',
    DEFAULT_YEAR_MANAGER: 'Default year for managers',
    DEFAULT_YEAR_MANAGER_DESC: 'The year that will be displayed by default when managers access compensation management',
    DEFAULT_YEAR_UPDATED: 'Default year updated successfully',
    EXCLUDED_USERS_TITLE: 'Excluded collaborators',
    EXCLUDED_USERS_DESC: 'Select the collaborators who must be hidden from the remuneration tables.',
    EXCLUDED_USERS_PLACEHOLDER: 'Search by name, team, site…',
    EXCLUDED_USERS_EMPTY: 'No collaborator matches your filters.',
    EXCLUDED_USERS_SELECTED: 'collaborator(s) excluded',
    EXCLUDED_USERS_UPDATED: 'Excluded collaborators updated successfully',
    EXCLUDED_USERS_SELECTED_LIST: 'Excluded collaborators',
    MANAGE_EXCLUDED_USERS: 'Manage excluded collaborators',
  },
  ONGLETS: {
    TITLE: 'Tab Management',
    BTN_ADD: 'Add Tab',
    ADD_NEW: 'New Tab',
    LABEL: 'Label',
    ORDER: 'Order',
    VISIBLE_MANAGER: 'Visible to manager',
    VISIBLE_MANAGER_HELP: 'This tab will be visible to payroll managers',
    PLACEHOLDER_LABEL: 'Enter tab label',
    NO_ONGLETS: 'No tabs configured',
    WARNING_ADMIN_ONLY: 'Only payroll administrators can manage tabs',
    ERROR_NOT_ADMIN: 'Access denied: you must be a payroll administrator',
    ERROR_LOAD: 'Error loading tabs',
    ERROR_CREATE: 'Error creating tab',
    ERROR_UPDATE: 'Error updating tab',
    ERROR_DELETE: 'Error deleting tab',
    ERROR_EMPTY_LABEL: 'Label cannot be empty',
    SUCCESS_CREATE: 'Tab created successfully',
    SUCCESS_UPDATE: 'Tab updated successfully',
    SUCCESS_DELETE: 'Tab deleted successfully',
    CONFIRM_DELETE: 'Are you sure you want to delete the tab "{{label}}"?',
  }
};
